<div class="toro-last-updated-container">
    <fa-icon *ngIf="!hideAlertBanner && alertText" icon="exclamation-triangle" [pTooltip]="alertText" tooltipStyleClass="widget-alert-tooltip"></fa-icon>
    <div *ngIf="lastUpdated">{{'STRINGS.WIDGET_LAST_UPDATED_LABEL' | translate: {duration: lastUpdated.duration, scale: lastUpdated.scale} }}</div>
</div>
